import type { Table } from '@tanstack/react-table';

import type { CatalogItem } from '@/entities/catalog-item';
import { additionalColumnsList, defaultColumnsList, moreColumnsList } from '../../../constants';

const getActiveColumnCount = (table: Table<CatalogItem>) => {
  const visibilityById = new Map(
    table.getAllColumns().map(column => [column.id, column.getIsVisible()])
  );
  const allToggleableColumns = [
    ...defaultColumnsList,
    ...additionalColumnsList,
    ...moreColumnsList
  ];

  return allToggleableColumns.filter(({ accessorKey }) => visibilityById.get(accessorKey)).length;
};

export default getActiveColumnCount;
